import { render, staticRenderFns } from "./AreasOfConcernTips.vue?vue&type=template&id=0569a24e&"
import script from "./AreasOfConcernTips.vue?vue&type=script&lang=js&"
export * from "./AreasOfConcernTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports